import { FunctionComponent } from 'react';
import { BAT_BODY_PATH, BAT_LEFT_WING, BAT_RIGHT_WING, BAT_VIEW_BOX } from '../batShapes';

import classes from './BatFigure.module.scss';

const WING_KEY_TIMES = '0;0.18;0.4;0.7;1';

const WING_KEY_SPLINES = '0.4 0 0.6 1;0.4 0 0.6 1;0.4 0 0.6 1;0.4 0 0.6 1';

interface BatFigureProps {
  flapDuration: number;
  flapBegin?: number;
}

export const BatFigure: FunctionComponent<BatFigureProps> = ({ flapDuration, flapBegin = 0 }) => {
  const timing = {
    dur: `${flapDuration}s`,
    begin: `${flapBegin}s`,
    repeatCount: 'indefinite',
    calcMode: 'spline',
  };

  return (
    <svg className={classes['bat-figure']} viewBox={BAT_VIEW_BOX}>
      <g>
        <animateTransform
          attributeName={'transform'}
          type={'translate'}
          values={'0 1.5;0 -1.5;0 1.5'}
          keyTimes={'0;0.4;1'}
          keySplines={'0.4 0 0.6 1;0.4 0 0.6 1'}
          {...timing}
        />
        <path d={BAT_RIGHT_WING.restPath}>
          <animate
            attributeName={'d'}
            values={BAT_RIGHT_WING.flapValues}
            keyTimes={WING_KEY_TIMES}
            keySplines={WING_KEY_SPLINES}
            {...timing}
          />
        </path>
        <path d={BAT_LEFT_WING.restPath}>
          <animate
            attributeName={'d'}
            values={BAT_LEFT_WING.flapValues}
            keyTimes={WING_KEY_TIMES}
            keySplines={WING_KEY_SPLINES}
            {...timing}
          />
        </path>
        <path d={BAT_BODY_PATH} />
      </g>
    </svg>
  );
};
